import React from 'react';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import PageHeading from '../../components/PageHeading/PageHeading.js';
import BackLink from '../../components/BackLink/BackLink';

import withBaseLayout from '../../components/BaseLayout/withBaseLayout.js';

import { getString } from '../../helpers/stringHelpers';

import { withStyles } from '@material-ui/core/styles';
import styles from './styles.js';

const stringsComponent = 'profile';

class ProfileLayout extends React.Component {
  render() {
    const {
      classes,
      tenancyInformationLanding,
      accountDetailsLanding,
      contactDetailsLanding,
      emergencyContactsLanding,
      consentedPersonsLanding,
      notificationsLanding,
      settingsButton,
      settingsDialog,
      backAction,
    } = this.props;

    return (
      <div className={classes.root}>
        <BackLink action={backAction} />
        <PageHeading heading={getString(stringsComponent, 'TITLE')} />
        <Grid container spacing={24}>
          <Grid item xs={12} lg={6}>
            {tenancyInformationLanding}
          </Grid>
          <Grid item xs={12} lg={6}>
            {accountDetailsLanding}
          </Grid>
          <Grid item xs={12} lg={6}>
            {contactDetailsLanding}
          </Grid>
          <Grid item xs={12} lg={6}>
            {emergencyContactsLanding}
          </Grid>
          <Grid item xs={12} lg={6}>
            {consentedPersonsLanding}
          </Grid>
          <Grid item xs={12} lg={6}>
            {notificationsLanding}
          </Grid>
        </Grid>
        {settingsDialog}
        <BackLink action={backAction} gutterTop={true} />
      </div>
    );
  }
}

ProfileLayout.propTypes = {
  classes: PropTypes.object.isRequired,
  tenancyInformationLanding: PropTypes.object.isRequired,
  accountDetailsLanding: PropTypes.object.isRequired,
  contactDetailsLanding: PropTypes.object.isRequired,
  emergencyContactsLanding: PropTypes.object.isRequired,
  consentedPersonsLanding: PropTypes.object.isRequired,
  settingsButton: PropTypes.object,
  settingsDialog: PropTypes.object,
};

export default withBaseLayout(
  withStyles(styles, { withTheme: true })(ProfileLayout)
);
